import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const PendingTaskWrapper = () => {

    return (
        <Fragment>
            <Outlet/>
        </Fragment>
    )
}

export default PendingTaskWrapper